<template>
<div class="jumbotron jumbotron-fluid jumbotron-home">
    <div class="jumbotron-home-insider jumbotron-home-insider-alt with-polygons">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-10 offset-md-1">
                    <h1 class="h1-forms">Dołącz do wydarzenia</h1>

                    <form id="f-register" @submit.prevent="handlePasswordForm()" method="post">
                        <div class="form-row">
                            <form-input label="Hasło:" size="col-md-12" type="password" name="password" id="password" :modelValue="password" v-model="password" :error-messages="errorMessages" extraInfo="Należy podać hasło dostępu do wydarzenia."></form-input>
                        </div>

                        <div class="form-group text-center">
                            <button type="submit" class="btn btn-primary btn-lg">Dołącz do wydarzenia</button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>

    <notifications group="foo" />

</div>
</template>

<script>
    import FormInput from "./formInput";
    import FormSelect from "./formSelect";
    import FormTextarea from "./formTextarea";
    import Spinner from 'vue-simple-spinner';
    import FormUserType from "./formUserType";
    import FormAgreementInput from "./formAgreementInput";
    import FormUserAgreementInput from "./formUserAgreementInput";

    export default {
        props: ['webinar_id', 'webinar_slug'],

        components: {
            FormInput,
            Spinner
        },
        data() {
            return {
                password: null,
                webinarId: this.webinar_id,
                webinarSlug: this.webinar_slug,
                errorMessages: [],
            }
        },

        methods: {
            handlePasswordForm() {
                axios.post('/api/webinar/checkPassword', {
                    password: this.password,
                    webinarId: this.webinarId,
                })
                .then(response => {
                    this.processing = true;
                })
                .then(response => {
                    this.processing = false;
                    window.location.href = '/wydarzenie/' + this.webinarId + '/' + this.webinarSlug + '/zapisz-sie';
                })
                .catch(error => {
                    this.errorMessages = error.response.data.errors;
                    this.$notify({
                        'group': 'foo',
                        'type': 'error',
                        'title': error.response.data.message,
                    });
                }).then(error => {
                    window.scrollTo(0, document.querySelector('.error').offsetParent.offsetTop);
                });
            },
        }

    }
</script>
